// start MSW (mock service worker)
import { getAppUrl } from './Auth'


export async function enableMocking() {
	if (import.meta.env.DEV && import.meta.env.VITE_API_MOCK === 'true') {
		const { worker } = await import(`../mocks/ajax/browser.js`)
		return worker.start({
			serviceWorker: {
				url: getAppUrl('mockServiceWorker.js'),
			},
		})
	}
	return Promise.resolve()
}
